import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Base class for synthesis results
 * @class SynthesisResult
 * Added in version 1.20.0
 */
export var SynthesisResult = /*#__PURE__*/function () {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */
  function SynthesisResult(resultId, reason, errorDetails, properties) {
    _classCallCheck(this, SynthesisResult);

    this.privResultId = resultId;
    this.privReason = reason;
    this.privErrorDetails = errorDetails;
    this.privProperties = properties;
  }
  /**
   * Specifies the result identifier.
   * @member SynthesisResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */


  _createClass(SynthesisResult, [{
    key: "resultId",
    get: function get() {
      return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member SynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */

  }, {
    key: "reason",
    get: function get() {
      return this.privReason;
    }
    /**
     * In case of an unsuccessful synthesis, provides details of the occurred error.
     * @member SynthesisResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */

  }, {
    key: "errorDetails",
    get: function get() {
      return this.privErrorDetails;
    }
    /**
     *  The set of properties exposed in the result.
     * @member SynthesisResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */

  }, {
    key: "properties",
    get: function get() {
      return this.privProperties;
    }
  }]);

  return SynthesisResult;
}();